"use client";

import React from "react";
import { Zap } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HolDirDenUnbegrenztenTurbo() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222301" id="demand-attention" className="bg-background text-foreground py-24 px-4 md:px-8 overflow-hidden relative" ref={ref}>
      {}
      <style>{`
        @keyframes customScalePulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.02); }
        }
        .animate-custom-scale-pulse {
          animation: customScalePulse 3s infinite ease-in-out;
        }
      `}</style>

      <div className={`max-w-5xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        {}
        <div className="relative rounded-none p-[1px] bg-border shadow-none">
          
          {}
          <div className="bg-background rounded-none p-8 md:p-16 lg:p-24 flex flex-col items-center text-center gap-10 relative overflow-hidden">

            {}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-lg h-full max-h-lg bg-primary/5 blur-[160px] rounded-full pointer-events-none" />

            <div className="relative z-10 space-y-6 max-w-3xl">
              <h2 className="text-4xl md:text-5xl lg:text-8xl font-bold font-default text-foreground leading-none tracking-tighter uppercase">
                Demand Attention
              </h2>

              <p className="text-lg md:text-xl text-muted-foreground font-mono max-w-2xl mx-auto uppercase tracking-widest">
                Cinematic artistry for brands that refuse to be ignored. Elevate your visual narrative.
              </p>
            </div>

            <div className="relative z-10 mt-4">
              <Button asChild size="lg" className="animate-custom-scale-pulse h-16 px-10 md:px-14 text-lg md:text-xl font-bold rounded-none bg-primary text-primary-foreground hover:bg-primary/90 shadow-none border-none transition-colors">
                <Link to="/StartProjectPage">
                  Start a Project <Zap className="ml-3 size-6 fill-current" />
                </Link>
              </Button>
            </div>
            
          </div>
        </div>
      </div>
    </section>;
}